// Prompt M — the wizard's option lists. `value` / `id` is what the backend receives (unchanged,
// English); `key` is the i18n key of what the buyer sees.

export const SECTORS = [
  { value: "Industrial", key: "wiz.sector.industrial" },
  { value: "Mining", key: "wiz.sector.mining" },
  { value: "Utilities", key: "wiz.sector.utilities" },
  { value: "Telecom", key: "wiz.sector.telecom" },
];

// Typical continuous-operation load factors by sector (editable per project via
// the Load & demand step). Sourced from spec §4 sector load defaults.
export const SECTOR_LOAD_FACTOR = {
  Industrial: 0.70,
  Mining: 0.85,
  Utilities: 0.60,
  Telecom: 0.75,
};

// Cement is NOT a tile: it is an Industrial application ("Cement / heavy
// industry"). The backend still accepts sector "Cement" and load_shape.py keeps
// its kiln archetype. "other" is the buyer's own description (GA-UI-1 D2).
export const APPLICATIONS = {
  Industrial: [
    { value: "Manufacturing plant", key: "wiz.app.manufacturing" },
    { value: "Warehouse / logistics", key: "wiz.app.warehouse" },
    { value: "Agro-processing", key: "wiz.app.agro" },
    { value: "Cement / heavy industry", key: "wiz.app.cement" },
    { value: "Cold chain / food", key: "wiz.app.cold_chain" },
    { value: "other", key: "wiz.app.other" },
  ],
  Mining: [
    { value: "Open-pit mine", key: "wiz.app.open_pit" },
    { value: "Underground mine", key: "wiz.app.underground" },
    { value: "Processing plant", key: "wiz.app.processing" },
    { value: "Camp & offices", key: "wiz.app.camp" },
    { value: "Exploration site", key: "wiz.app.exploration" },
    { value: "other", key: "wiz.app.other" },
  ],
  Utilities: [
    { value: "Independent power producer (IPP)", key: "wiz.app.ipp" },
    { value: "Distribution utility", key: "wiz.app.distribution" },
    { value: "Mini-grid operator", key: "wiz.app.minigrid" },
    { value: "Grid-connected renewable", key: "wiz.app.grid_renewable" },
    { value: "other", key: "wiz.app.other" },
  ],
  Telecom: [
    { value: "Macro tower site", key: "wiz.app.macro_tower" },
    { value: "Regional aggregation site", key: "wiz.app.aggregation" },
    { value: "Data centre / edge", key: "wiz.app.data_centre" },
    { value: "Fibre network hub", key: "wiz.app.fibre_hub" },
    { value: "other", key: "wiz.app.other" },
  ],
};

export const GRIDS = [
  { id: "on_grid", key: "wiz.grid.on_grid" },
  { id: "weak_grid", key: "wiz.grid.weak_grid" },
  { id: "off_grid", key: "wiz.grid.off_grid" },
];

export const OWNERSHIPS = [
  { id: "captive", key: "wiz.own.captive" },
  { id: "IPP", key: "wiz.own.IPP" },
  { id: "BOO", key: "wiz.own.BOO" },
  { id: "PPP", key: "wiz.own.PPP" },
  { id: "ESCO", key: "wiz.own.ESCO" },
  { id: "lease", key: "wiz.own.lease" },
];

export const THERMAL_TECHS = {
  gas_engine: { title: "wiz.th.gas_engine.title", body: "wiz.th.gas_engine.body" },
  ocgt: { title: "wiz.th.ocgt.title", body: "wiz.th.ocgt.body" },
  ccgt: { title: "wiz.th.ccgt.title", body: "wiz.th.ccgt.body" },
};

export const GAS_SOURCES = [
  { id: "pipeline", key: "wiz.th.src.pipeline" },
  { id: "lng", key: "wiz.th.src.lng" },
  { id: "cng", key: "wiz.th.src.cng" },
  { id: "lpg", key: "wiz.th.src.lpg" },
];
